/* eslint  no-unused-vars: 0 */
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  // [::1] is the IPv6 localhost address.
  window.location.hostname === '[::1]' ||
  // 127.0.0.1/8 is considered localhost for IPv4.
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
);

let hostname = window.location.hostname;

// Everything defaults to staging
let base_hostname = `api.${process.env.REACT_APP_PROD_PATH}.ipermitpro.com`;
if(process.env.NODE_ENV === 'development') {
  base_hostname = 'api.dev.ipermitpro.com';
}

let mock_base_hostname = 'localhost:4000';

const api = `https://${base_hostname}/api/`;
//const api = 'http://localhost:3000/api/';
const mock_api = `http://${mock_base_hostname}/`;

const AWS_URL_PREFIX =  ()=> {
  const env = 'prod';
  //let env = process.env.NODE_ENV === 'production' ? 'prod' : 'dev';
  return `https://analytics.${env}.api.ipermiteraters.com`;
};

let base_url = {
  hostname: base_hostname,
  api: api,
  mock_api,
  aws_api: AWS_URL_PREFIX(),
};

const urlSearchParams = {
  duplicateOfId: 'duplicateOfId',
  draftId: 'draftId',
  stateLicenseNumber: 'stateLicenseNumber',
  companyId: 'companyId',
  completeOnboarding: 'completeOnboarding',
  redirect: 'redirect',
  invite: 'invite',
  openTab: 'openTab',
  moduleName: 'moduleName',
  submodule: 'submodule',
  view: 'view',
  failedInspections: 'failedInspections',
  userId: 'userId',
  raterId: 'raterId',
  timeline: 'timeline',
};

export default base_url;
export {urlSearchParams};
